import { render, staticRenderFns } from "./YagiprimeWrapper.vue?vue&type=template&id=cacc67a8&scoped=true"
import script from "./YagiprimeWrapper.vue?vue&type=script&lang=js"
export * from "./YagiprimeWrapper.vue?vue&type=script&lang=js"
import style0 from "./YagiprimeWrapper.vue?vue&type=style&index=0&id=cacc67a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacc67a8",
  null
  
)

export default component.exports